import React from 'react';
import {Modal, type ModalProps} from '@udemy-v2/react-dialog-components';
import {CoursePreview} from './course-preview.react-component';
import styles from '@/features/course-landing-page/components/course-preview-entry-point/course-preview-entry-point.module.scss';
import {ColorScheme} from '@udemy-v2/styles';

interface CoursePreviewModalProps {
    onClose: ModalProps['onClose'];
    isOpen: ModalProps['isOpen'];
    uiRegion: string;
    selectedLectureId?: string;
}

export const CoursePreviewModal = ({
    onClose,
    isOpen,
    uiRegion,
    selectedLectureId,
}: CoursePreviewModalProps) => {
    return (
        <ColorScheme colorScheme="dark" className={styles.wrapper}>
            <Modal
                renderTitle={() => ['title-in-body-modal-title', null]}
                title=""
                isOpen={isOpen}
                onClose={onClose}
            >
                <CoursePreview uiRegion={uiRegion} selectedLectureId={selectedLectureId} />
            </Modal>
        </ColorScheme>
    );
};
